import { gql } from 'graphql-request';
import { contentfulQuery } from '../../../utilities/contentful';
import type { Fields } from '../interface';

interface QueryResponse {
  swsAboutPageSectionsCollection: {
    items: Fields[];
  };
}

type FieldNames =
  | 'careers-hero'
  | 'careers-workWithUs'
  | 'careers-benefits'
  | 'careers-gallery'
  | 'careers-values'
  | 'careers-teamReviews'
  | 'careers-journey'
  | 'careers-location';

export const queryKey = ['CAREERS_CONTENT'] as const;

export async function getCareers() {
  const query = gql`
    query getCareers {
      swsAboutPageSectionsCollection(
        where: {
          id_in: [
            "careers-hero"
            "careers-workWithUs"
            "careers-benefits"
            "careers-gallery"
            "careers-values"
            "careers-teamReviews"
            "careers-journey"
            "careers-location"
          ]
        }
      ) {
        items {
          id
          title
          subtitle
          shortContentOne
          shortContentTwo
          shortContentThree
          shortContentFour
          longContentOne
          longContentTwo
          longContentThree
          longContentFour
          longContentFive
          longContentSix
          longContentSeven
          longContentEight
          longContentNine
          longContentTen
          buttonOneLabel
          featureImage {
            url
            title
            description
          }
          galleryCollection {
            items {
              url
              title
              description
            }
          }
        }
      }
    }
  `;

  const contentfulData = await contentfulQuery<QueryResponse>(query);

  const data = contentfulData.swsAboutPageSectionsCollection.items.reduce(
    (obj, item) => {
      return {
        ...obj,
        [item.id]: item,
      };
    },
    {}
  ) as Record<FieldNames, Fields>;

  const gallery = data['careers-gallery'].galleryCollection.items.slice(0, 4);
  const mobileGallery = {
    top: data['careers-gallery'].galleryCollection.items.slice(0, 2),
    bottom: data['careers-gallery'].galleryCollection.items.slice(2, 4),
  };
  return { ...data, gallery, mobileGallery };
}
